import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import { renderToStaticMarkup } from "react-dom/server";
import LockedImage from "../../images/LockedImage";
import { Close } from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import { useAuth } from "../../context/Auth";


const svgString = encodeURIComponent(renderToStaticMarkup(<LockedImage />));

const AccessDenied = () => {
    const { logout } = useAuth();

    const onClose = _ => {
        logout();
    }

    return (
        <Dialog
            open={true}
            maxWidth="md"
        >
            <DialogTitle
                sx={theme => ({
                    width: theme.spacing(75),
                    minWidth: theme.spacing(75),
                    height: theme.spacing(40),
                    minHeight: theme.spacing(40),
                    backgroundImage: `url("data:image/svg+xml,${svgString}")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    padding: 0
                })}
            >
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: grey[500],
                    }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: theme => theme.spacing(0, 3, 2) }}>
                <Typography
                    variant="h6"
                    align="center"
                    sx={{
                        fontWeight: 550,
                        padding: theme => theme.spacing(1, 0)
                    }}
                >
                    Access Denied
                </Typography>
                <Typography
                    color="textSecondary"
                    align="center"
                    sx={{ pt: 1 }}
                >
                    For some reason, CityPass could not identify you, <br />
                    Try logging in with a different account.<br />
                    If the problem persists contact your system administrator.
                </Typography>
            </DialogContent>
            <DialogActions
                sx={{
                    padding: theme => theme.spacing(2, 3, 4),
                    justifyContent: 'center'
                }}
            >
                <Button
                    autoFocus
                    onClick={onClose}
                    color="primary"
                >
                    Login with a different account
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AccessDenied;
